<script setup>
/**
 * @description 商城商品名前活动类型标签：秒杀、赠品、组合促销、搭配等描边标签
 */
</script>

<template>
  <span v-if="$slots.default" class="store-activity-tag">
    <slot />
  </span>
</template>

<style lang="scss" scoped>
.store-activity-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 20px;
  padding: 0 6px;
  margin-right: 6px;
  border: 1px solid $primary-color;
  border-radius: 6px;
  background-color: transparent;
  color: $primary-color;
  font-size: $font-size-caption;
  font-weight: 400;
  line-height: 18px;
  vertical-align: 1px;
  box-sizing: border-box;
  white-space: nowrap;
}
</style>
